export default __webpack_public_path__ + "static/media/personal-site-sm.abcdfa7f.jpg";